import React, { FunctionComponent, useCallback, useEffect } from 'react';

import { ModalConfirm } from '../../../../../../shared/components';
import { i18n } from '../../../../../../shared/helpers/i18n';
import { countMetrika } from '../../../../../../shared/helpers/metrika';
import { useSummarizationMailRecipientCheckboxState } from '../../hooks/use-summarization-mail-recipient-checkbox-state';
import { SummarizationMailRecipientCheckbox } from '../summarization-mail-recipient-checkbox';
import { SummarizationModalProps } from '../types';

export const SummarizationStopModal: FunctionComponent<SummarizationModalProps> = ({ onClose: closeHandler }) => {
    const [checkboxState, setCheckboxState] = useSummarizationMailRecipientCheckboxState();

    useEffect(() => countMetrika('meeting_screen', 'summarization', 'stop_popup_was_shown'), []);

    const onConfirm = () =>
        closeHandler?.({
            isConfirmed: true,
            isSummarizationMailForParticipants: checkboxState.checked,
        });
    const onCancel = () => closeHandler?.({ isConfirmed: false });

    const onCheckboxChange = useCallback(
        (event: React.ChangeEvent<HTMLInputElement>) => {
            setCheckboxState({
                checked: event.target.checked,
            });
        },
        [setCheckboxState]
    );

    return (
        <ModalConfirm
            onClose={onCancel}
            onCancel={onCancel}
            onConfirm={onConfirm}
            headerText={i18n('summarization', 'stop-dialog-title')}
            cancelButtonText={i18n('summarization', 'stop-dialog-deny-v2')}
            confirmButtonText={i18n('summarization', 'stop-dialog-submit-v2')}
        >
            {i18n('summarization', 'stop-dialog-content-v2')}
            <SummarizationMailRecipientCheckbox {...checkboxState} onChange={onCheckboxChange} />
        </ModalConfirm>
    );
};
